type Props = {
  current: number;
  total: number;
  onChange: (page: number) => void;
};

function buildPages(current: number, total: number): (number | string)[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | string)[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("...");
  pages.push(total);
  return pages;
}

export default function Pagination({ current, total, onChange }: Props) {
  if (total <= 1) return null;
  const pages = buildPages(current, total);

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-200 bg-background-100 px-3 text-sm font-label text-foreground-700 transition-colors duration-200 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
        上一页
      </button>
      {pages.map((p, idx) =>
        typeof p === "number" ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`flex h-9 w-9 items-center justify-center rounded-md text-sm font-label transition-colors duration-200 cursor-pointer ${
              p === current
                ? "bg-primary-500 text-background-50"
                : "border border-background-200 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`gap-${idx}`} className="px-1 text-foreground-400">
            ...
          </span>
        ),
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="flex h-9 items-center gap-1 rounded-md border border-background-200 bg-background-100 px-3 text-sm font-label text-foreground-700 transition-colors duration-200 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </div>
  );
}